<nav id="thefooter" class="navbar navbar-custom navbar-expand-lg">
  <div >
    <div>&copy; Reflexis</div>
  </div>

  <ul class="navbar-nav ml-auto footer-nav">
    <li class="nav-item"><a routerLinkActive="active" routerLink="/privacy" style="text-decoration: unset;">PRIVACY POLICY</a> | </li>
    <li class="nav-item"><a routerLinkActive="active" routerLink="/disclaimer" style="text-decoration: unset;">DISCLAIMER</a> | </li>
    <li class="nav-item"><a  routerLinkActive="active" routerLink="/terms-conditions" style="text-decoration: unset;">TERMS OF USE</a></li>
  </ul>
</nav>
